
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M135.41 67.09l-13-11.79-3.84-3.3-43.39-38.34L26.57 55h-.11v.09L12.51 67m14-12.13v75.73h95.9V55.18"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M57.75 75.54v10A11.67 11.67 0 0069.41 97.2h10a11.67 11.67 0 0011.66-11.66v-10a11.67 11.67 0 00-11.66-11.66h-10a11.67 11.67 0 00-11.66 11.66z"}})])
          )
        }
      }
    